import React from 'react';
import PropTypes from 'prop-types';

import EmptyTableAlert from '../EmptyTableAlert';
import List from '../List';

const TableContent = ({ isTableEmpty, itemName, numberOfColumns, ...listProps }) => {
  if (!isTableEmpty) return <List {...listProps} />;
  return <EmptyTableAlert numberOfColumns={numberOfColumns} message={`No ${itemName} to show!`} />;
};
TableContent.propTypes = {
  isTableEmpty: PropTypes.bool.isRequired,
  itemName: PropTypes.string.isRequired,
  numberOfColumns: PropTypes.number.isRequired
};

export default TableContent;
